import { render, staticRenderFns } from "./InsuranceSkeleton.vue?vue&type=template&id=5f3fb99c&scoped=true"
import script from "./InsuranceSkeleton.vue?vue&type=script&lang=js"
export * from "./InsuranceSkeleton.vue?vue&type=script&lang=js"
import style0 from "./InsuranceSkeleton.vue?vue&type=style&index=0&id=5f3fb99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3fb99c",
  null
  
)

export default component.exports